import { Component } from '@angular/core';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileFormComponent } from './components/login/profile-form/profile-form.component';
import { LandingModelComponent } from './common/ngbmodel/landing-model/landing-model.component';
import { PopupsubmitDataComponent } from './components/submitdata/popupsubmit-data/popupsubmit-data.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'NMCGFrontEnd';
  userdetails = {};
  modalRef: any;
  constructor(
    private modalService: NgbModal,
    private logsrv : AuthloginService,
    ) { }
  ngOnInit() {
    this.userdetails = this.logsrv.checkloginstatus();
    this.popupSubmit();
  }
  profileForm(){
    if(this.userdetails){
      if(this.userdetails['roles'][0] == "DISTRICT_GANGA_COMMITTEE"){
      this.modalRef = this.modalService.open(ProfileFormComponent,{backdrop: 'static',windowClass: 'backgroundTransparent my-class modal-dialog-centered'});
    }
  } else{
    this.logsrv.clearsession();
  }
  }
  popupSubmit(){
    if(this.userdetails!=null && this.userdetails!=undefined){
      this.modalRef = this.modalService.open(PopupsubmitDataComponent,{
        centered:true, backdrop: 'static', keyboard: false
      });
    }
  }
}


